import { Navigate, useLocation } from "react-router-dom";

export default function EventIndexPage() {
  const location = useLocation();
  const isUniversityEventsRoute = location.pathname.startsWith("/education/universities/");
  const defaultTab = isUniversityEventsRoute ? "registrations" : "overview";

  return <Navigate to={`${location.pathname}/${defaultTab}`} replace />;
}
